import React from 'react';
import "./SingleSkill.css";

export const SingleSkill = (props) => {

  const renderSwitch = (param) => {
    switch (param) {
      case 5:
        return (
          <div className="skillDots">
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
          </div>
        )
      case 4:
        return (
          <div className="skillDots">
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
          </div>
        )
      case 3:
        return (
          <div className="skillDots">
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
          </div>
        )
      case 2:
        return (
          <div className="skillDots">
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
          </div>
        )
      case 1:
        return (
          <div className="skillDots">
            <span className="material-symbols-outlined filled">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
          </div>
        )
      default:
        return (
          <div className="skillDots">
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
            <span className="material-symbols-outlined">
              circle
            </span>
          </div>
        )
    }
  }

  return (
    <div className='singleSkill'>
      <span className='skillName'>{props.skillName ? props.skillName : "Empty skill"}</span>
      {renderSwitch(props.dots)}
    </div>
  );
}